module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0017.jpg?v=eae0b5e3";